document.addEventListener('DOMContentLoaded', function () {
  var path = window.location.pathname.replace(/\/$/, '');
  if (path !== '') return;

  var section = document.querySelector('[id$="__archford_core_collections"]');
  if (!section) return;

  var list = section.querySelector('ul');
  if (!list) return;

  if (list.querySelector('a[href="/collections/lockout-tagout"], a[href$="/collections/lockout-tagout"]')) return;

  var item = document.createElement('li');
  item.className = 'archford-home-category-card archford-phase2-lockout-card';
  item.innerHTML = '<figure><a href="/collections/lockout-tagout" aria-label="Shop Lockout Tagout"><img src="https://cdn.shopify.com/s/files/1/0877/1407/0833/files/sh02_1024x_2x_8db46a91-f78e-48e8-b361-cf31221df3f2.webp?v=1761187282&amp;width=600" alt="Lockout Tagout products" loading="lazy" width="600" height="600"></a></figure><h4><a href="/collections/lockout-tagout">Lockout Tagout <span aria-hidden="true">›</span></a></h4>';

  var rubberLink = list.querySelector('a[href="/collections/rubber-tag"], a[href$="/collections/rubber-tag"]');
  var rubberItem = rubberLink ? rubberLink.closest('li') : null;
  if (rubberItem) list.insertBefore(item, rubberItem);
  else list.appendChild(item);
});
